import type { MenuProps } from 'antd';
import { GlobalOutlined, CheckOutlined } from '@ant-design/icons';
import type { AppLocale } from '../../i18n/types';
import { APP_LOCALES } from '../../i18n/types';

type TFunction = (key: string) => string;

/**
 * Items menu avatar pour la bascule FR/EN.
 */
export function buildLanguageMenuItems(options: {
  locale: AppLocale;
  t: TFunction;
}): NonNullable<MenuProps['items']> {
  const { locale, t } = options;

  return [
    { type: 'divider' },
    {
      key: 'language_group',
      type: 'group',
      label: t('language.label'),
      children: APP_LOCALES.map((code) => ({
        key: `locale_${code}`,
        icon: code === locale ? <CheckOutlined /> : <GlobalOutlined />,
        label: t(`language.${code}`),
      })),
    },
  ];
}

/** Parse une clé menu `locale_fr` / `locale_en`. */
export function parseLocaleMenuKey(key: string): AppLocale | null {
  if (key === 'locale_fr') return 'fr';
  if (key === 'locale_en') return 'en';
  return null;
}
